import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StatusChangeHistory } from "@common/models";
import { environment } from "environments/environment";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";


@Injectable({providedIn: 'root'})
export class StatusChangeHistoryService {
    constructor(private _http: HttpClient){}

    /**
     * Obtiene un historial de cambio de estado a través del Id del menu y el ID del objeto
     * @param {number} menuId - Id del menu
     * @param {number} objectId - Id del objeto
     * @returns {Observable<StatusChangeHistory[]>} Respuesta del consumo de la API
     */
    getByMenuIdAndObjectId(menuId: Number, objectId: String | Number): Observable<StatusChangeHistory[]>{
        return this._http.get<StatusChangeHistory[]>(`${environment.commonApiUrl}/api/status-change-history/${menuId}/${objectId}`);
    }

    /**
     * Añade un nuevo historial de cambio de estado
     * @param {StatusChangeHistory} statusChangeHistory - historial a crear
     * @returns {Observable<StatusChangeHistory[]>} Respuesta del consumo de la API
     */
    addStatusChangeHistory(statusChangeHistory: StatusChangeHistory, reset: boolean): Observable<StatusChangeHistory[]>{
        return this._http.post<StatusChangeHistory[]>(`${environment.commonApiUrl}/api/status-change-history/${reset}`, statusChangeHistory)
        .pipe(
            map((response: any) => response.statusChangeHistoryList as StatusChangeHistory[]),
            catchError(e => {
                return throwError(e)
            })
        )
    }
}
